import { Box, Typography } from '@mui/material';
import ReusableGrid from '../../../../components/Grid';
import DataNotFound from '../../../../components/Reports/DataNotFound';

export const Card = ({ data, title, columns }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography fontWeight={600} variant="h5">
        {title}
      </Typography>
      {data.length === 0 ? (
        <DataNotFound />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {data.map((item) => {
            const totals = item.items.reduce(
              (acc, row) => {
                const raw = row.hours;
                const value =
                  raw === null || raw === undefined ? '' : String(raw).trim();
                if (!value) return acc;
                if (value.startsWith('$')) {
                  const amount = parseFloat(
                    value.replace(/[$,\s]/g, '') || '0'
                  );
                  if (!Number.isNaN(amount)) acc.amount += amount;
                } else {
                  const hours = parseFloat(value.replace(/[,\s]/g, '') || '0');
                  if (!Number.isNaN(hours)) acc.hours += hours;
                }
                return acc;
              },
              { hours: 0, amount: 0 }
            );

            const footerValue = totals.hours === 0 ? `Total Amount: $${totals.amount}` : `Total Hours: ${totals.hours}`;

            const footer = columns.map((col) =>
              col.field === 'hours' ? footerValue : ''
            );

            return (
              <Box
                key={item.title || JSON.stringify(item)}
                sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}
              >
                {item.title && (
                  <Typography fontWeight={500} variant="h6">
                    {item.title}
                  </Typography>
                )}

                <ReusableGrid
                  columns={columns}
                  rows={item.items}
                  footer={footer}
                />
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};
